import React from 'react';
import { Heart, Calendar, ExternalLink, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Column 1: Company Info */}
          <div className="flex flex-col items-center md:items-start">
            <img 
              src="https://images.squarespace-cdn.com/content/v1/5b8d80bc50a54f3097036fbc/1546638478704-ITJL00DVVX93GXFZ4FY1/logo_transparent_background.png?format=750w" 
              alt="Maximum Effectiveness Logo" 
              className="h-10 mb-4"
            />
            <p className="text-sm text-gray-600 mb-4 text-center md:text-left">
              Helping you discover your true potential through Enneagram insights and personalized coaching.
            </p>
          </div>
          
          {/* Column 2: Quick Links */}
          <div className="flex flex-col items-center">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://www.maximumeffectiveness.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-600 hover:text-[#2B5AB8] transition-colors"
                >
                  <ExternalLink className="h-4 w-4 mr-2" />
                  <span>Main Website</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://www.maximumeffectiveness.com/book-online" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-600 hover:text-[#2B5AB8] transition-colors"
                >
                  <Calendar className="h-4 w-4 mr-2" />
                  <span>Book an Appointment</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://www.maximumeffectiveness.com/about" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-600 hover:text-[#2B5AB8] transition-colors"
                >
                  <ExternalLink className="h-4 w-4 mr-2" />
                  <span>About Us</span>
                </a>
              </li>
            </ul>
          </div>
          
          {/* Column 3: Contact */}
          <div className="flex flex-col items-center md:items-end">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="mailto:kathy@maximumeffectiveness.com" 
                  className="flex items-center text-gray-600 hover:text-[#2B5AB8] transition-colors"
                >
                  <Mail className="h-4 w-4 mr-2" />
                  <span>kathy@maximumeffectiveness.com</span>
                </a>
              </li>
              <li>
                <a 
                  href="tel:+17209798473" 
                  className="flex items-center text-gray-600 hover:text-[#2B5AB8] transition-colors"
                >
                  <Phone className="h-4 w-4 mr-2" />
                  <span>(720) 979-8473</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://www.maximumeffectiveness.com/book-online" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center mt-4 px-4 py-2 bg-[#2B5AB8] text-white rounded-md hover:bg-[#224A96] transition-colors"
                >
                  <Calendar className="h-4 w-4 mr-2" />
                  <span>Schedule a Session</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-8 pt-6 flex flex-col items-center">
          <div className="flex items-center space-x-2 mb-2">
            <span className="text-gray-500">Made with</span>
            <Heart className="h-4 w-4 text-red-500" />
            <span className="text-gray-500">for spiritual growth</span>
          </div>
          <div className="text-sm text-gray-400">
            © {new Date().getFullYear()} Maximum Effectiveness, LLC. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;